// 签到区域奖品图
export const signinRewardImg: any = {
  fragment: {
    icon: require('@/images/signIn/signin_fragment.png'),
    iconLeak: require('@/images/signIn/signin_fragment_leak.png'),
  },
  money: {
    icon: require('@/images/signIn/signin_money.png'),
    iconLeak: require('@/images/signIn/signin_money_leak.png'),
  },
  gift: {
    icon: require('@/images/signIn/signin_gift.png'),
    iconLeak: require('@/images/signIn/signin_gift_leak.png'),
  },
};

// 连续签到天数
export const numImg: any = {
  1: require('@/images/signIn/num1.png'),
  2: require('@/images/signIn/num2.png'),
  3: require('@/images/signIn/num3.png'),
  4: require('@/images/signIn/num4.png'),
  5: require('@/images/signIn/num5.png'),
  6: require('@/images/signIn/num6.png'),
  7: require('@/images/signIn/num7.png'),
};

// 使用哪个方向弹出popover
type GetPosition =
  | 'left'
  | 'right'
  | 'bottom'
  | 'top'
  | 'topLeft'
  | 'topRight'
  | 'bottomLeft'
  | 'bottomRight'
  | 'leftTop'
  | 'leftBottom'
  | 'rightTop'
  | 'rightBottom';
export const getPosition = (index: number): GetPosition => {
  let placement: GetPosition = 'left';
  switch (index) {
    case 0:
    case 4:
      placement = 'topLeft';
      break;
    case 3:
    case 6:
      placement = 'topRight';
      break;
    default:
      placement = 'top';
  }
  return placement;
};

/**
 * @description: 计算奖品
 * @param {any} datas 数据源
 * @param {number} type  1碎片 2成长值 3菜品  4数量
 * @param {number} seriesState  是否连签 1是0否
 * @param {number} isNeedSeries  是否需要根据连签状态计算 true 需要  false不需要
 */
export const calcNum = (
  datas: any,
  type: number,
  seriesState: number,
  isNeedSeries?: boolean,
) => {
  if (!datas) {
    return 0;
  }
  const { dishesCount, fragment, fragmentSeries, growth, growthSeries } = datas;
  const dishesTotal = dishesCount;
  const fragmentTotal =
    seriesState === 1 || !isNeedSeries ? fragment + fragmentSeries : fragment;
  const growthTotal =
    seriesState === 1 || !isNeedSeries ? growth + growthSeries : growth;
  let num = 0;
  if (dishesTotal > 0) num++;
  if (fragmentTotal > 0) num++;
  if (growthTotal > 0) num++;
  switch (type) {
    case 1:
      return fragmentTotal;
    case 2:
      return growthTotal;
    case 3:
      return dishesTotal;
    case 4:
      return num;
  }
};

export interface ToggleRemined {
  type?: string;
  needRemined?: boolean;
  closeMsg?: string;
  needApi?: boolean;
}
